// 初始化数据
const modal = {
  searchResult: [], //查询结果数据
  orderDetailData: {}, //订单详情接口返回数据
  searchParams: {}, // 搜索传值
  deliverResult: [], //物流轨迹数据
  total: 0, // 查询总数
  page: 1, // 当前页码
  size: 10, // 当前分页数
  tableLoading: false, // 列表loading
  action: '', //是否是编辑或者新增
  isShowSearch: false, //是否显示高级查询
  superClass: 0, //工具栏按钮
  selectedRowKeys: [], //选择的行
  tabList: [
    { name: '待发货', num: '' },
    { name: '已发货', num: '' },
    { name: '已签收', num: '' },
    { name: '已取消', num: '' },
  ],
  totalAmount: {},
  deliverStatusTurn: {
    0: '无轨迹',
    1: '已揽件',
    2: '在途中',
    3: '签收',
    4: '问题件',
  },
  deliverTraceStatusTurn: {
    1: '已揽件',
    2: '在途中',
    201: '到达派件城市',
    202: '派件中',
    211: '已放入快递柜或驿站',
    3: '已签收',
    301: '正常签收',
    302: '派件异常后最终签收',
    304: '代收签收',
    311: '快递柜或驿站签收',
    4: '问题件',
    401: '发货无信息',
    402: '超时未签收',
    403: '超时未更新',
    404: '拒收(退件)',
    405: '派件异常',
    406: '退货签收',
    407: '退货未签收',
  },
};
export default modal;
